<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
      <v-checkbox
            v-model="enableResearchInBook"
            :label="$t('fields.enable_research_in_book')"
            color="primary"
            :value=true
            hide-details
        >
      </v-checkbox>

        <ValidationProvider
            v-if="enableResearchInBook"
            rules="required"
            vid="sku"
            :name="$t('fields.sku').toLowerCase()"
            v-slot="{ errors }"
        >
          <AutoComplete
            v-model="searchSku"
            key-value="id"
            key-name="fulltext"
            enable-chips
            enable-clearable
            enable-autofocus
            :items="books"
            :label="$t('fields.sku')"
            @search="searchSku"
            @input="fetchSkuIfExist"
            @clear="deleteSelectedSku"
            :delay="900"
            :errors="errors"
          >
          </AutoComplete>
        </ValidationProvider>

        <ValidationProvider
            v-if="!enableResearchInBook"
            rules="required"
            vid="sku"
            :name="$t('fields.sku').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.sku"
            :counter="30"
            :label="$t('fields.sku')"
            :error-messages="errors"
          ></v-text-field>

        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="propagandist"
            :name="$t('fields.propagandist').toLowerCase()"
            v-slot="{ errors }"
        >
          <PropagandistSelect
            v-model=" form.propagandist_id"
            :label="$t('fields.propagandist')"
            :errors="errors"
          ></PropagandistSelect>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="qty"
            :name="$t('fields.quantity').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.qty"
            type="number"
            :label="$t('fields.quantity')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import { booksService } from '../../../utils/services/books.service';

  import AutoComplete from '../../shared/Inputs/AutoComplete.vue';
  import PropagandistSelect from '../../shared/Vselects/PropagandistSelect.vue';


  export default {
    name: 'WarehouseUnloadModal',
    components: {
      AutoComplete,
      PropagandistSelect,
    },
    data() {
      return {
        stored: null,
        enableResearchInBook: true,
        form: {
          sku: null,
          qty: null,
          propagandist_id: null,
        },
        books: [],
        filters: {
          searchSku: null,
        },
        loading: false,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [true],
          sortBy: ['title'],
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      requestFilters() {
        const filters = {
          search: this.filters.searchSku,
        };

        return filters;
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      async searchSku(val) {
        this.filters.searchSku = val;
        await this.fetchBooks(1);
      },

      deleteSelectedSku() {
        this.books = [];
      },

      async fetchSkuIfExist(id) {
        if (id > 0) {
          await this.fetchBook(id);
        } else {
          this.form.name = '';
        }
      },

      async fetchBooks(forcePage) {
        this.loadingBook = true;
        const { page, itemsPerPage } = this.pagination;
        return booksService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.books = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loadingBook = false;
          });
      },
      async fetchBook(id) {
        this.loadingBook = true;
        return booksService.get(id)
          .then(response => {
            this.form.sku = response.data.data.isbn;
            this.form.name = response.data.data.fulltext;
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loadingBook = false;
          });
      },
      cancel() {
        this.hideModal({});
      },
    },
  };
</script>
